import { connect } from 'react-redux'
import WorkshiftJournalRowComponent from '../../components/invoice/workshiftJournalRow.component'
import { attachWorkshiftJournalId } from '../../actions'

const mapStateToProps = (state) => {
  const invoiceEdit = state.invoice.invoiceEdit
  let edit_invoice_id = null
  if (invoiceEdit.length > 0) {
    edit_invoice_id = invoiceEdit[0].Invoice[0].invoice_id
  }
  return {
    state,
    attachedWorkShiftJournalIds: state.invoice.attachedWorkShiftJournalIds,
    isEditInvoice: state.invoice.isEdit,
    edit_invoice_id: edit_invoice_id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    attachWorkshiftJournalId: (journal_id) =>
      dispatch(attachWorkshiftJournalId(journal_id))
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const WorkshiftJournalRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorkshiftJournalRowComponent)

export default WorkshiftJournalRowContainer
